document.addEventListener("DOMContentLoaded", function (event) {
  const productItem = document.querySelectorAll(".product-compare-item");
  const productCompare = document.querySelectorAll(".yg-compare-product-box");
  const componentTab = document.querySelectorAll(".component-tab");
  const componentHeading = document.querySelectorAll(
    ".component-tab .tab-heading",
  );
  const componentTabContent = document.querySelectorAll(
    ".component-tab-content",
  );

  const learnMoreBtn = document.querySelectorAll('.yg-multi-more');
  console.log("learnMoreBtn", learnMoreBtn);
    if (learnMoreBtn.length > 0) {
        learnMoreBtn.forEach((btn, index) => {
            btn.addEventListener('click', function(e){
                console.log("e", e)
                const content = e.target.offsetParent.querySelector('.prose p')
                content.classList.toggle('clamp');
                if (content.classList.contains('clamp')) {
                    btn.textContent = 'Learn Less';
                } else {
                    btn.textContent = 'Learn More';
                }
            })
        })
  }
  const basicItem = document.querySelectorAll(".basic-compare-item");

  function getDataFromSessionStorage(productId) {
    const storedData = sessionStorage.getItem(`productData_${productId}`);
    return storedData ? JSON.parse(storedData) : null;
  }
  let compareBoxIndex = sessionStorage.getItem("compareBoxIndex");

  if (productItem.length > 0) {
    function updateProductData(productItem) {
      const productCompare = document.querySelectorAll(".yg-compare-product-box");
      productItem.forEach((item, index) => {
        const product = item.querySelector(".product-compare-frame");
        const select = item.querySelector(".product-compare-select");
        const compareId = productCompare[index].dataset.id;
        const compareHandle = productCompare[index].dataset.compareHandle;
        const img = item.querySelector(".product-compare-img");
        const title = item.querySelector(".product-compare-heading");
        const des = item.querySelector(".product-compare-des");
        const price = item.querySelector(".product-compare-price");
        const link = item.querySelector(".product-compare-link");
        product.dataset.id = compareId;
        product.dataset.handle = compareHandle;
        const productInfo = productCompare[index].dataset.productInfo;
        const compareInfo = productCompare[index].dataset.compareInfo;
        const basicDiv = document.createElement("div");
        basicDiv.classList.add("basic-info");
        basicDiv.innerHTML = productInfo;
        basicItem[index].appendChild(basicDiv);
        const parser = new DOMParser();
        const doc = parser.parseFromString(compareInfo, "text/html");
        const componentBoxes = doc.querySelectorAll(".component-box");
        componentBoxes.forEach((box, innerIndex) => {
          const heading = box.querySelector(".component-heading");
          const content = box.querySelector(".component-content");
          if (content) {
            componentTabContent[innerIndex].innerHTML += content.innerHTML.trim();
          }
          if (heading) {
            if (heading && componentHeading[innerIndex]) {
              componentHeading[innerIndex].textContent =
                  heading.textContent.trim();
            }
          }
        });

        const productData = getDataFromSessionStorage(compareId);
        if (productData) {
          product.classList.remove("hidden");
          select.classList.add("hidden");
          title.textContent = productData.title;
          price.innerHTML = productData.price;
          des.textContent = productData.des;
          link.href = productData.url;
          img.src = productData.image;
        }
      });
    }
    updateProductData(productItem)

    const componentSpan = document.querySelectorAll(
      ".component-tab-content .metafield-rich_text_field p",
    );
    componentSpan.forEach((paragraph) => {
      const fragment = document.createDocumentFragment();
    });
    componentSpan.forEach((paragraph) => {
      const children = paragraph.childNodes;
      children.forEach((child) => {
        if (child.tagName === "STRONG") {
          let nextNode = child.nextSibling;
          while (nextNode && nextNode.nodeType !== Node.TEXT_NODE) {
            nextNode = nextNode.nextSibling;
          }
          if (nextNode) {
            const span = document.createElement("span");
            span.textContent = nextNode.textContent;
            nextNode.replaceWith(span);
          }
        }
      });
    });
    componentTab.forEach((tab, index) => {
      tab.addEventListener("click", function (event) {
        tab.classList.toggle("active");
        componentTabContent[index].classList.toggle("active");
      });
    });
    const basicBox = document.querySelectorAll(".basic-compare-item");
    const contentBox = document.querySelectorAll(
      ".component-tab-content .metafield-rich_text_field",
    );

    const compareContainer = document.querySelector(".yg-compare-container");
    const compareButton  = document.querySelector(".yg-compare-btn");

    function clearProductBox(){
      const productRemove = document.querySelectorAll(".product-compare-remove");
      productRemove.forEach((button, index) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          const item = event.target.closest(".product-compare-item");
          const product = item.querySelector(".product-compare-frame");
          const productId = product.dataset.id;
          const compareBoxArray = Array.from(document.querySelectorAll(".yg-compare-product-box"));
          const compareBoxToRemove = compareBoxArray.find(
              (box) => box.dataset.id === productId,
          );
          if (compareBoxToRemove) {
            sessionStorage.removeItem(`product${productId}Checked`);
            sessionStorage.removeItem(`compareBoxHTML${productId}`);
            sessionStorage.removeItem(`productData_${productId}`);
            let compareBoxIndex = Number(sessionStorage.getItem("compareBoxIndex"));
            compareBoxIndex--;
            sessionStorage.setItem("compareBoxIndex", compareBoxIndex.toString());
            const number = document.querySelector(".compare-number");
            number.textContent = compareBoxIndex.toString();
            const compareBox = Array.from(document.querySelectorAll(".yg-compare-product-box"));
            const compareBoxHTMLValues = [];
            compareBox.forEach((box) => {
              const compareBoxHTML = sessionStorage.getItem(`compareBoxHTML${box.dataset.id}`);
              if (compareBoxHTML !== null) {
                compareBoxHTMLValues.push(compareBoxHTML);
              }
            });
            compareBox.forEach((box, index) => {
              if (compareBoxHTMLValues[index]) {
                box.outerHTML = compareBoxHTMLValues[index];
              } else {
                resetCompareProductBox(box)
              }
            });
            if(compareBoxIndex < 2){
              sessionStorage.setItem("compareButtonActive", 'false');
              compareButton.classList.remove('active')
            }
            if(compareBoxIndex === 0){
              clearAllData();
            }
          }
          clearData();
          updateProductData(productItem);
        });
      });
    }
    clearProductBox();

    function clearData(){
      const productItem = document.querySelectorAll(".product-compare-item");
      Array.from(productItem).forEach(item => {
        const product = item.querySelector('.product-compare-frame');
        const select = item.querySelector(".product-compare-select");
        const img = product.querySelector(".product-compare-img");
        const title = product.querySelector(".product-compare-heading");
        const des = product.querySelector(".product-compare-des");
        const price = product.querySelector(".product-compare-price");
        const link = product.querySelector(".product-compare-link");
        product.dataset.id = '';
        product.dataset.handle = '';
        title.textContent = "";
        price.innerHTML = "";
        des.textContent = "";
        link.href = "";
        img.src = "";
        product.classList.add("hidden");
        select.classList.remove("hidden");
        basicBox.forEach(box=>{
          box.innerHTML = ""
        })
        const contentBox = document.querySelectorAll(
            ".component-tab-content .metafield-rich_text_field",
        );
        contentBox.forEach(box=>{
          box.innerHTML = ""
          box.remove();
        })
      });
    }

    if (sessionStorage.getItem("compareContainerActive") === false) {
      compareContainer.classList.remove("active");
    }
    const clearProduct = document.querySelector(".yg-compare-clear");

    clearProduct.addEventListener("click", function (event) {
      productItem.forEach((item, index) => {
        const product = item.querySelector(".product-compare-frame");
        product.classList.add("hidden");
        const select = item.querySelector(".product-compare-select");
        select.classList.remove("hidden");
      })
      contentBox.forEach(box=>{
        box.innerHTML = ""
      })
      basicBox.forEach(box=>{
        box.innerHTML = ""
      })
    })
    function removeProduct() {
      const compareRemove = document.querySelectorAll(".compare-remove");
      compareRemove.forEach((button, index) => {
        button.addEventListener("click", function (event) {
          clearProductComparison();
        });
      });
    }
    removeProduct();
    function clearProductComparison() {
      clearData();
      updateProductData(productItem);
      let compareBoxIndex = Number(sessionStorage.getItem("compareBoxIndex"));
      console.log("compareBoxIndex: ", compareBoxIndex)
      removeProduct();
      if(compareBoxIndex === 0){
        clearAllData()
      }
    }
    function clearAllData() {
        sessionStorage.setItem(`compareButtonActive`, 'false');
        sessionStorage.setItem(`compareContainerActive`, 'false');
        sessionStorage.removeItem(`compareContainerActive`);
        sessionStorage.removeItem(`compareButtonActive`);
        sessionStorage.removeItem(`compareBoxIndex`);
        compareContainer.classList.add('hide');
        compareContainer.classList.remove('active');
    }

    function resetCompareProductBox(event) {
      event.dataset.id = '';
      event.dataset.compareHandle = '';
      event.dataset.compareDes = '';
      event.dataset.productInfo = '';
      event.dataset.compareInfo = '';
      event
        .querySelector(".yg-compare-product-placeholder")
        .removeAttribute("hidden");
      event.querySelector(".yg-compare-product").setAttribute("hidden", "");
      event.querySelector(".yg-compare-product-title").textContent = "";
      event.querySelector(".yg-compare-product-title").setAttribute("href", "");
      event.querySelector("img").src = "";
      event.querySelector(".yg-compare-product-price").innerHTML = "";
    }
  }
});

// mega menu
document.addEventListener('DOMContentLoaded', function() {
  (function(){
    let ygMegaMenu3 = document.querySelectorAll('.yg-mega-menu-3');

    ygMegaMenu3.forEach(function(menu){
      let ygMegaMenu3Tab = menu.querySelectorAll('.yg-mega-menu__nav-title-tab');
      let ygMegaMenu3Content = menu.querySelectorAll('.yg-mega-menu__nav-content');

      ygMegaMenu3Tab.forEach(function(tab,index){
        tab.addEventListener('click', function(){
          ygMegaMenu3Tab.forEach(function(tab, i){
            tab.classList.remove('active');
            ygMegaMenu3Content[i].classList.remove('active');
          })

          tab.classList.add('active');
          ygMegaMenu3Content[index].classList.add('active');
        })
      })
    })
  }())
})


document.addEventListener('DOMContentLoaded', function() {
  if (!window.customElements.get("yg-reviews2-swiper")) {
    window.customElements.define("yg-reviews2-swiper", YGReviews2Swiper);
  }
});

// YG Reviews2 Swiper
class YGReviews2Swiper extends HTMLElement {
  constructor() {
        super();
        const url = this.getAttribute('data-load-script')
        this.loadScript(url, () => {
        this.init() // 调用自定义方法
        })
  }

  loadScript(url, fn) {
    if (url) {
        let loadScript = document.createElement('script')
        loadScript.src = url
        document.body.appendChild(loadScript)

        loadScript.onload = () => {
            fn()
        }

        loadScript.onerror = (err) => {
            console.error(err)
        }
        }
    }

  init(){
      const swiper = this.querySelector(".yg-reviews2-swiper");
      const pagination = this.querySelector(".swiper-pagination");
      const nextEl = this.querySelector(".yg-button-next");
      const prevEl = this.querySelector(".yg-button-prev");

      new Swiper(swiper, {
            spaceBetween: 30,
            pagination: {
                el: pagination,
                type: "progressbar",
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            }
      });
  }
};


document.addEventListener('DOMContentLoaded', function() {
  if (!window.customElements.get("yg-reviews-swiper")) {
    window.customElements.define("yg-reviews-swiper", YGReviewsSwiper);
  }
});

// YG Reviews Swiper
class YGReviewsSwiper extends HTMLElement {
  constructor() {
        super();
        const url = this.getAttribute('data-load-script')
        this.loadScript(url, () => {
        this.init() // 调用自定义方法
        })
  }

  loadScript(url, fn) {
    if (url) {
        let loadScript = document.createElement('script')
        loadScript.src = url
        document.body.appendChild(loadScript)

        loadScript.onload = () => {
            fn()
        }

        loadScript.onerror = (err) => {
            console.error(err)
        }
        }
    }

  init(){
      const swiper = this.querySelector(".yg-reviews-swiper");
      const pagination = this.querySelector(".swiper-pagination");
      const nextEl = this.querySelector(".swiper-button-next");
      const prevEl = this.querySelector(".swiper-button-prev");

      new Swiper(swiper, {
          breakpoints: {
             300: {
                slidesPerView: 1.5,
                spaceBetween: 12
              },
             //当swiper宽度大于等于768
              768: {
                slidesPerView: 3,
                spaceBetween: 24
              },
              1200:{
                slidesPerView: 4,
                spaceBetween: 24
              },
              1600:{
                slidesPerView: 4,
                spaceBetween: 24
              }
            },
            pagination: {
                el: pagination
            },
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            }
      });
  }
};

class YGPopup extends HTMLElement {
  constructor() {
      super()
      this.openPopup()
      this.clonePopup()
  }
  openPopup() {
      // 这里放置自定义逻辑
      this.addEventListener("click",function(){
          let popupBox = document.querySelector(".yg-popup-box")
          let popupTemplate = this.querySelector("template") || this.querySelector(".yg-popup-template")

          popupBox.querySelector('.yg-popup-box-content-inner').innerHTML = popupTemplate.innerHTML
          document.querySelector('body').style.overflow = "hidden"
          popupBox.style.display = "flex"
      })
  }
  clonePopup() {
      let popupBox = document.querySelector(".yg-popup-box")
      popupBox.addEventListener("click",function(e){
          if(e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box'){
              popupBox.style.display = "none"
              popupBox.querySelector('.yg-popup-box-content-inner').innerHTML = ''
              document.querySelector('body').style.overflow = "auto"
          }
      })
  }
}
if (!window.customElements.get('yg-popup')) {
  window.customElements.define('yg-popup',YGPopup)
}

document.addEventListener('DOMContentLoaded', function() {
  // 移动端导航产品系列收缩

  const linksWrappers = document.querySelectorAll('.yg_mega_menu_1_links');
  if(linksWrappers) {
    linksWrappers.forEach(linksWrapper => {
      
      const headers = linksWrapper.querySelectorAll('.mega-menu__nav .justify-items-start');
      const links =  linksWrapper.querySelectorAll('.mega-menu__nav .justify-items-start .justify-items-start');

      headers.forEach(header => {
        header.addEventListener('click', () => {
          header.classList.toggle('active');
        })
      })
    })
  }
})

document.addEventListener('DOMContentLoaded', function() {
  const paypal_btn = document.querySelector('[data-shopify="payment-button"].shopify-payment-button');
  const custom_btn = document.querySelector('[is="yg-custom-payment-button"].button');
  if(paypal_btn && custom_btn && paypal_btn.querySelector('[data-testid="upstream-button"].shopify-payment-button__button')) {
    paypal_btn.style.display = 'none';
    custom_btn.style.display = 'block';

    custom_btn.addEventListener('click', function() {
      paypal_btn.click();
    })
  }

  const quick_btn = document.querySelector('[is="yg-custom-quick-button"].button');
  if(quick_btn) {
    quick_btn.addEventListener('click', () => {
      let buyItNow = document.querySelector('[data-shopify="payment-button"].shopify-payment-button button');
      buyItNow.click();
    })
  }
})

